import config from 'netxcore@netx/core-asset/config';

Object.assign(config, {
	PAGE_SIZE: 30,
	CHUNK_SIZE: 30,
	DETAIL_TABS: ['preview', 'fileinfo', 'attributes', 'list'],
	DRAGGABLE: false,
	EQUAL_GRID: true, // default false
	LIST_TYPE: ['card', 'curator', 'grid', 'list'],
	LIST_TYPE_DEFAULT: 'card',
	LIST_TYPES_ENABLED: false,

	CATEGORY_ASSETS_MINI: false,
	SEARCH_ASSETS_MINI: false,
	CART_ASSETS_MINI: false,
	ZOOM_CONTAINER_ID: 'modal',
});

export default config;
